(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gt-boutique-souvenirs"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('qs-carousel'))customElements.define('qs-carousel',class extends HTMLElement{
 connectedCallback(){this.slides=[...this.querySelectorAll('.qs-slide')];this.dots=[...this.querySelectorAll('[data-dot]')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.pause=this.querySelector('[data-pause]');this.querySelector('[data-prev]').onclick=()=>this.manual(this.index-1);this.querySelector('[data-next]').onclick=()=>this.manual(this.index+1);this.dots.forEach((b,i)=>b.onclick=()=>this.manual(i));this.pause.onclick=()=>{this.paused=!this.paused;this.updatePause()};this.addEventListener('focusin',event=>{if(event.target!==this.pause){this.paused=true;this.updatePause()}});this.updatePause();this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.matches(':hover'))this.show(this.index+1)},6000)}
 disconnectedCallback(){clearInterval(this.timer)}
 updatePause(){this.pause.textContent=this.paused?this.pause.dataset.playText:this.pause.dataset.pauseText;this.pause.setAttribute('aria-pressed',String(this.paused));this.querySelector('.qs-slides').setAttribute('aria-live',this.paused?'polite':'off')}
 manual(i){this.paused=true;this.updatePause();this.show(i)}
 show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>{let active=n===this.index;s.classList.toggle('is-active',active);s.setAttribute('aria-hidden',String(!active));s.inert=!active;this.dots[n].setAttribute('aria-current',String(active))})}
});
if(!customElements.get('qs-rail'))customElements.define('qs-rail',class extends HTMLElement{connectedCallback(){let rail=this.querySelector('.qs-rail');this.querySelector('[data-left]').onclick=()=>rail.scrollBy({left:-rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});this.querySelector('[data-right]').onclick=()=>rail.scrollBy({left:rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}});
document.addEventListener('click',event=>{let link=event.target.closest('.qs-boutique [data-open]');if(!link)return;let panel=document.getElementById(link.dataset.open);if(panel)panel.open=true});


function qsPauseForMedia(){document.querySelectorAll("qs-carousel").forEach(carousel=>{carousel.paused=true;carousel.updatePause?.()})}
document.addEventListener("play",event=>{if(event.target.matches?.(".qs-boutique video"))qsPauseForMedia()},true);
window.addEventListener("blur",()=>{setTimeout(()=>{if(document.activeElement?.matches(".qs-concept iframe"))qsPauseForMedia()},0)});


if(!customElements.get("qs-media-showcase"))customElements.define("qs-media-showcase",class extends HTMLElement{connectedCallback(){if(this.bound)return;this.bound=true;this.addEventListener("play",event=>{if(event.target.tagName!=="VIDEO")return;this.stopOthers(event.target);event.target.parentElement.classList.add("is-playing");qsPauseForMedia()},true);this.addEventListener("pause",event=>{if(event.target.tagName==="VIDEO")event.target.parentElement.classList.remove("is-playing")},true);this.addEventListener("ended",event=>{if(event.target.tagName==="VIDEO")event.target.parentElement.classList.remove("is-playing")},true);this.addEventListener("click",event=>{const play=event.target.closest("[data-video-play]");if(play){const video=play.parentElement.querySelector("video");this.stopOthers(video);video.play().catch(()=>video.parentElement.classList.remove("is-playing"));return}const youtube=event.target.closest("[data-youtube-play]");if(youtube){this.stopOthers();qsPauseForMedia();const box=youtube.closest("[data-youtube-id]");const frame=document.createElement("iframe");frame.src="https://www.youtube.com/embed/"+box.dataset.youtubeId+"?autoplay=1&enablejsapi=1&playsinline=1&rel=0&origin="+encodeURIComponent(location.origin);frame.title=box.dataset.videoTitle;frame.allow="autoplay; encrypted-media; picture-in-picture; fullscreen";frame.allowFullscreen=true;box.append(frame);youtube.hidden=true;box.parentElement.querySelector("[data-stop-video]").hidden=false;return}if(event.target.closest("[data-stop-video]"))this.stopOthers()})}stopOthers(keep){this.querySelectorAll("video").forEach(video=>{if(video!==keep)video.pause()});this.querySelectorAll(".qs-youtube-player iframe").forEach(frame=>frame.remove());this.querySelectorAll("[data-youtube-play]").forEach(button=>button.hidden=false);this.querySelectorAll("[data-stop-video]").forEach(button=>button.hidden=true)}});

function qsFocusLinkedVideo(){const target=document.getElementById(location.hash.slice(1));if(!target?.matches(".qs-video-card"))return;const rail=target.closest(".qs-video-rail");if(rail)rail.scrollTo({left:target.offsetLeft-rail.offsetLeft,behavior:"auto"});target.scrollIntoView({block:"start",inline:"nearest",behavior:"auto"})}
window.addEventListener("load",qsFocusLinkedVideo);window.addEventListener("hashchange",qsFocusLinkedVideo);if(document.readyState==="complete")qsFocusLinkedVideo();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-produits-spirituels"] && !Shopify.designMode) return;
  try {
    


if(!customElements.get('qs-carousel'))customElements.define('qs-carousel',class extends HTMLElement{
 connectedCallback(){this.slides=[...this.querySelectorAll('.qs-slide')];this.dots=[...this.querySelectorAll('[data-dot]')];this.index=0;this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;this.pause=this.querySelector('[data-pause]');this.querySelector('[data-prev]').onclick=()=>this.manual(this.index-1);this.querySelector('[data-next]').onclick=()=>this.manual(this.index+1);this.dots.forEach((b,i)=>b.onclick=()=>this.manual(i));this.pause.onclick=()=>{this.paused=!this.paused;this.updatePause()};this.addEventListener('focusin',event=>{if(event.target!==this.pause){this.paused=true;this.updatePause()}});this.updatePause();this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.matches(':hover'))this.show(this.index+1)},7000)}
 disconnectedCallback(){clearInterval(this.timer)}
 updatePause(){this.pause.textContent=this.paused?this.pause.dataset.playText:this.pause.dataset.pauseText;this.pause.setAttribute('aria-pressed',String(this.paused));this.querySelector('.qs-slides').setAttribute('aria-live',this.paused?'polite':'off')}
 manual(i){this.paused=true;this.updatePause();this.show(i)}
 show(i){this.index=(i+this.slides.length)%this.slides.length;this.slides.forEach((s,n)=>{let active=n===this.index;s.classList.toggle('is-active',active);s.setAttribute('aria-hidden',String(!active));s.inert=!active;this.dots[n].setAttribute('aria-current',String(active))})}
});
if(!customElements.get('qs-rail'))customElements.define('qs-rail',class extends HTMLElement{connectedCallback(){let rail=this.querySelector('.qs-rail');this.querySelector('[data-left]').onclick=()=>rail.scrollBy({left:-rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});this.querySelector('[data-right]').onclick=()=>rail.scrollBy({left:rail.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})}});
document.addEventListener('click',event=>{let link=event.target.closest('.qs-boutique [data-open]');if(!link)return;let panel=document.getElementById(link.dataset.open);if(panel)panel.open=true});



if(!customElements.get('qs-video'))customElements.define('qs-video',class extends HTMLElement{connectedCallback(){const button=this.querySelector('button');button.addEventListener('click',()=>{const frame=this.querySelector('template').content.cloneNode(true);button.replaceWith(frame);this.querySelector('iframe').focus()},{once:true})}});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gt-vitrine-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => {
  if (root.dataset.gtVideoReady) return;
  root.dataset.gtVideoReady = 'true';
  const rail = root.querySelector('.posters');
  const release = () => {
   const active = root.querySelector('.poster-video[data-gt-open]');
   if (!active) return;
   active.querySelector('iframe')?.remove();
   active.querySelector('[data-gt-close-video]')?.remove();
   const cover = active.querySelector('[data-gt-load-video]');
   if (cover) cover.hidden = false;
   delete active.dataset.gtOpen;
   delete root.dataset.gtPlaying;
   root.querySelectorAll('[data-gt-prev],[data-gt-next]').forEach(b => b.disabled = false);
   cover?.focus({preventScroll:true});
  };
  root.addEventListener('click', e => {
   if (e.target.closest('[data-gt-close-video]')) {
    e.preventDefault();e.stopImmediatePropagation();release();return;
   }
   const play = e.target.closest('[data-gt-load-video]');
   if (!play) return;
   e.preventDefault();e.stopImmediatePropagation();
   release();
   const wrap = play.closest('.poster-video');
   const template = wrap?.querySelector('template[data-gt-external]');
   if (!template) return;
   wrap.append(template.content.cloneNode(true));
   play.hidden = true;
   wrap.dataset.gtOpen = 'true';
   root.dataset.gtPlaying = 'true';
   root.querySelectorAll('[data-gt-prev],[data-gt-next]').forEach(b => b.disabled = true);
   const close = document.createElement('button');
   close.type = 'button';close.className = 'gt-video-close';close.dataset.gtCloseVideo = '';
   close.textContent = root.dataset.gtCloseLabel;
   wrap.append(close);
  },true);
  rail?.addEventListener('keydown', e => {
   if (root.dataset.gtPlaying && ['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) e.preventDefault();
  });
  root.addEventListener('keydown',e=>{if(e.key==='Escape' && root.dataset.gtPlaying){e.preventDefault();release();}});
 };
 document.querySelectorAll('gt-discovery').forEach(init);
 document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('gt-discovery').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
